import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { registerServiceWorker } from './lib/pwa/registerServiceWorker';
import './styles/global.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('ไม่พบ element #root สำหรับ mount แอป');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

registerServiceWorker({
  enabled: import.meta.env.PROD,
  onError: (error) => {
    console.warn('ลงทะเบียน service worker ไม่สำเร็จ', error);
  },
});
